import { formatDateAndTimeTz, userTimeZone } from '@shared/utils/date';
import { numberColumnDefaults } from './columns/NumberColumn';
import {
  DateRangeColumnFilter,
  dateRangeFilterFn,
} from './filter/DateRangeColumnFilter';
import type { DataType, ExtendedColumnDef, UnknownTextTree } from './types';

type DataTypeConfig = Partial<ExtendedColumnDef<any, UnknownTextTree>>;

const config: Record<DataType, DataTypeConfig> = {
  date: {
    Filter: DateRangeColumnFilter,
    filterFn: dateRangeFilterFn,
    sortFn: 'datetime',
    sortUndefined: -1,
    meta: {
      filterLabel: (filterValue, { column }) => {
        if (!Array.isArray(filterValue)) {
          return '';
        }
        const [f, t] = filterValue;
        if (typeof f !== 'number' || typeof t !== 'number') {
          return '';
        }
        const tz = column.columnDef.meta?.timeZone ?? userTimeZone();
        return [
          formatDateAndTimeTz(new Date(f), tz),
          formatDateAndTimeTz(new Date(t), tz),
        ].join(' ... ');
      },
    },
  },
  number: numberColumnDefaults,
};

export function getColumnDefaults(dataType: DataType | undefined) {
  if (dataType === undefined) {
    return null;
  }
  return config[dataType];
}
